import nationalGridLogoSrc from "public/img/power/national-grid-logo.svg";
import northernPowergridLogoSrc from "public/img/power/norther-powergrid-logo.svg";
import scottishSouthernElectricityNetworksLogoSrc from "public/img/power/scottish-souther-electricity-networks-logo.svg";
import spElectricityNorthWestLogoSrc from "public/img/power/sp-electricity-north-west-logo.svg";
import spEnergyNetworksLogoSrc from "public/img/power/sp-energy-networks-logo.svg";
import ukPowerNetworksLogoSrc from "public/img/power/uk-power-networks-logo.svg";

import { DNO } from "./types";

export const DNO_LOGOS: Record<DNO, string> = {
  ENWL: spElectricityNorthWestLogoSrc,
  NPG: northernPowergridLogoSrc,
  SPEN: spEnergyNetworksLogoSrc,
  SSEN: scottishSouthernElectricityNetworksLogoSrc,
  UKPN: ukPowerNetworksLogoSrc,
  WPD: nationalGridLogoSrc,
};

/**
 * @todo extend the designation attribute model to allow for ordering via the data itself?
 */
export const SUBSTATION_ATTRIBUTE_ORDER = [
  // attribute group: "substation_headline",
  "substation_type",
  "voltage_range",
  "voltage",
  "voltage_kv",
  "voltage_v",
  "rag_status",
  "capacity_mva",
  "capacity_mw",
  "generation_rag",
  "generation_headroom_mva",
  "generation_headroom_mw",
  "demand_rag",
  "demand_headroom_mva",
  "demand_headroom_mw",
  "generation_mva",
  "demand_mva",

  // attribute group: "substation_kva_ratings",
  "kva_rating_min",
  "kva_rating_max",
  "kva_ratings",

  // attribute group: "substation_site_info",
  "site_id",
  "site_name",
  "site_classification",
  "district",
  "licence_area",
  "grid_substation_name",
  "associated_grid_group",
  "supergrid_group",
  "bulk_supply_group",
  "grid_supply_group",
  "associated_supergrid_group",
  "upstream_substation",
  "transformer_count",

  // other (ungrouped)
  "primary_voltage",
  "primary_voltage_kv",
  "primary_voltage_v",
  "downstream_voltage",
  "downstream_voltage_kv",
  "downstream_voltage_v",
  "demand_mw",
  "demand_constraints",
  "demand_headroom_band",
  "firm_capacity_summer_mw",
  "firm_capacity_winter_mw",
  "unutilised_capacity_percent",
  "generation_connected_mw",
  "generation_contracted_mw",
  "generation_constraints",
  "mounting_type",
  "numberoftransformers",
  "kva_rating",
  "primary_feeder_name",
  "primary_feeder_site_id",
  "substation_group",
  "site_purpose",
  "season_of_constraint",
  "predicted_year_of_reinforcement",
  "notes",
];
